export const COUNTRY_CODES = [
  { "USA": "1" },
  { "India": "91" },
  { "Canada": "1" },
  { "United Arab Emirates": "971" },
  { "Singapore": "65" },
];

export const NOT_SUPPORTED_COUNTRIES = [
  ...COUNTRY_CODES,
  { "UK": "44" },
  { "Algeria": "213" },
  { "Andorra": "376" },
  { "Angola": "244" },
  { "Anguilla": "1264" },
  { "Antigua & Barbuda": "1268" },
  { "Argentina": "54" },
  { "Armenia": "374" },
  { "Aruba": "297" },
  { "Australia": "61" },
  { "Austria": "43" },
  { "Azerbaijan": "994" },
  { "Bahamas": "1242" },
  { "Bahrain": "973" },
  { "Bangladesh": "880" },
  { "Barbados": "1246" },
  { "Belarus": "375" },
  { "Belgium": "32" },
  { "Belize": "501" },
  { "Benin": "229" },
  { "Bermuda": "1441" },
  { "Bhutan": "975" },
  { "Bolivia": "591" },
  { "Bosnia Herzegovina": "387" },
  { "Botswana": "267" },
  { "Brazil": "55" },
  { "Brunei": "673" },
  { "Bulgaria": "359" },
  { "Burkina Faso": "226" },
  { "Burundi": "257" },
  { "Cambodia": "855" },
  { "Cameroon": "237" },
  { "Cape Verde Islands": "238" },
  { "Cayman Islands": "1345" },
  { "Central African Republic": "236" },
  { "Chile": "56" },
  { "China": "86" },
  { "Colombia": "57" },
  { "Comoros": "269" },
  { "Congo": "242" },
  { "Cook Islands": "682" },
  { "Costa Rica": "506" },
  { "Croatia": "385" },
  { "Cuba": "53" },
  { "Cyprus North": "90392" },
  { "Cyprus South": "357" },
  { "Czech Republic": "42" },
  { "Denmark": "45" },
  { "Djibouti": "253" },
  { "Dominica": "1809" },
  { "Dominican Republic": "1809" },
  { "Ecuador": "593" },
  { "Egypt": "20" },
  { "El Salvador": "503" },
  { "Equatorial Guinea": "240" },
  { "Eritrea": "291" },
  { "Estonia": "372" },
  { "Ethiopia": "251" },
  { "Falkland Islands": "500" },
  { "Faroe Islands": "298" },
  { "Fiji": "679" },
  { "Finland": "358" },
  { "France": "33" },
  { "French Guiana": "594" },
  { "French Polynesia": "689" },
  { "Gabon": "241" },
  { "Gambia": "220" },
  { "Georgia": "7880" },
  { "Germany": "49" },
  { "Ghana": "233" },
  { "Gibraltar": "350" },
  { "Greece": "30" },
  { "Greenland": "299" },
  { "Grenada": "1473" },
  { "Guadeloupe": "590" },
  { "Guam": "671" },
  { "Guatemala": "502" },
  { "Guinea": "224" },
  { "Guinea - Bissau": "245" },
  { "Guyana": "592" },
  { "Haiti": "509" },
  { "Honduras": "504" },
  { "Hong Kong": "852" },
  { "Hungary": "36" },
  { "Iceland": "354" },
  { "Indonesia": "62" },
  { "Iran": "98" },
  { "Iraq": "964" },
  { "Ireland": "353" },
  { "Israel": "972" },
  { "Italy": "39" },
  { "Jamaica": "1876" },
  { "Japan": "81" },
  { "Jordan": "962" },
  { "Kazakhstan": "7" },
  { "Kenya": "254" },
  { "Kiribati": "686" },
  { "Korea North": "850" },
  { "Korea South": "82" },
  { "Kuwait": "965" },
  { "Kyrgyzstan": "996" },
  { "Laos": "856" },
  { "Latvia": "371" },
  { "Lebanon": "961" },
  { "Lesotho": "266" },
  { "Liberia": "231" },
  { "Libya": "218" },
  { "Liechtenstein": "417" },
  { "Lithuania": "370" },
  { "Luxembourg": "352" },
  { "Macao": "853" },
  { "Macedonia": "389" },
  { "Madagascar": "261" },
  { "Malawi": "265" },
  { "Malaysia": "60" },
  { "Maldives": "960" },
  { "Mali": "223" },
  { "Malta": "356" },
  { "Marshall Islands": "692" },
  { "Martinique": "596" },
  { "Mauritania": "222" },
  { "Mayotte": "269" },
  { "Mexico": "52" },
  { "Micronesia": "691" },
  { "Moldova": "373" },
  { "Monaco": "377" },
  { "Mongolia": "976" },
  { "Montserrat": "1664" },
  { "Morocco": "212" },
  { "Mozambique": "258" },
  { "Myanmar": "95" },
  { "Namibia": "264" },
  { "Nauru": "674" },
  { "Nepal": "977" },
  { "Netherlands": "31" },
  { "New Caledonia": "687" },
  { "New Zealand": "64" },
  { "Nicaragua": "505" },
  { "Niger": "227" },
  { "Nigeria": "234" },
  { "Niue": "683" },
  { "Norfolk Islands": "672" },
  { "Northern Marianas": "670" },
  { "Norway": "47" },
  { "Oman": "968" },
  { "Palau": "680" },
  { "Panama": "507" },
  { "Papua New Guinea": "675" },
  { "Paraguay": "595" },
  { "Peru": "51" },
  { "Philippines": "63" },
  { "Poland": "48" },
  { "Portugal": "351" },
  { "Puerto Rico": "1787" },
  { "Qatar": "974" },
  { "Reunion": "262" },
  { "Romania": "40" },
  { "Russia": "7" },
  { "Rwanda": "250" },
  { "San Marino": "378" },
  { "Sao Tome & Principe": "239" },
  { "Saudi Arabia": "966" },
  { "Senegal": "221" },
  { "Serbia": "381" },
  { "Seychelles": "248" },
  { "Sierra Leone": "232" },
  { "Slovak Republic": "421" },
  { "Slovenia": "386" },
  { "Solomon Islands": "677" },
  { "Somalia": "252" },
  { "South Africa": "27" },
  { "Spain": "34" },
  { "Sri Lanka": "94" },
  { "St. Helena": "290" },
  { "St. Kitts": "1869" },
  { "St. Lucia": "1758" },
  { "Sudan": "249" },
  { "Suriname": "597" },
  { "Swaziland": "268" },
  { "Sweden": "46" },
  { "Switzerland": "41" },
  { "Syria": "963" },
  { "Taiwan": "886" },
  { "Tajikstan": "7" },
  { "Thailand": "66" },
  { "Togo": "228" },
  { "Tonga": "676" },
  { "Trinidad & Tobago": "1868" },
  { "Tunisia": "216" },
  { "Turkey": "90" },
  { "Turkmenistan": "7" },
  { "Turkmenistan": "993" },
  { "Turks & Caicos Islands": "1649" },
  { "Tuvalu": "688" },
  { "Uganda": "256" },
  { "Ukraine": "380" },
  { "Uruguay": "598" },
  { "Uzbekistan": "7" },
  { "Vanuatu": "678" },
  { "Vatican City": "379" },
  { "Venezuela": "58" },
  { "Vietnam": "84" },
  { "Virgin Islands - British": "1284" },
  { "Virgin Islands - US": "1340" },
  { "Wallis & Futuna": "681" },
  { "Yemen North": "969" },
  { "Yemen South": "967" },
  { "Zambia": "260" },
  { "Zimbabwe": "263" },
]
// only array of supported countries
export const COUNTRY_CODES_ARR = COUNTRY_CODES.map((e) => {
  return {
    name: Object.keys(e)[0],
    value: Object.values(e)[0],
  }
})


export const ALL_COUNTRY_CODES_ARR = NOT_SUPPORTED_COUNTRIES.map((e) => {
  return {
    name: Object.keys(e)[0],
    value: Object.values(e)[0],
  }
})

// Subscriber-number length (digits, excluding the country/dial code) keyed
// by dial code. Covers every entry in NOT_SUPPORTED_COUNTRIES. Codes not
// in the map fall back to DEFAULT_MOBILE_LENGTH (ITU-T E.164 absolute bounds).
//
// Where multiple countries share a code (e.g. '1' for USA/Canada, '7' for
// Russia/Kazakhstan, '269' for Comoros/Mayotte, '1809' for
// Dominica/Dominican Republic) a single entry covers all of them.
export const MOBILE_LENGTH_BY_COUNTRY: Record<string, { min: number; max: number }> = {
  '1':     { min: 10, max: 10 }, // USA / Canada
  '91':    { min: 10, max: 10 }, // India
  '971':   { min: 9,  max: 9  }, // United Arab Emirates
  '65':    { min: 8,  max: 8  }, // Singapore
  '44':    { min: 10, max: 10 }, // UK
  '213':   { min: 9,  max: 9  }, // Algeria
  '376':   { min: 6,  max: 9  }, // Andorra
  '244':   { min: 9,  max: 9  }, // Angola
  '1264':  { min: 7,  max: 7  }, // Anguilla
  '1268':  { min: 7,  max: 7  }, // Antigua & Barbuda
  '54':    { min: 10, max: 11 }, // Argentina
  '374':   { min: 8,  max: 8  }, // Armenia
  '297':   { min: 7,  max: 7  }, // Aruba
  '61':    { min: 9,  max: 9  }, // Australia
  '43':    { min: 10, max: 13 }, // Austria
  '994':   { min: 9,  max: 9  }, // Azerbaijan
  '1242':  { min: 7,  max: 7  }, // Bahamas
  '973':   { min: 8,  max: 8  }, // Bahrain
  '880':   { min: 10, max: 10 }, // Bangladesh
  '1246':  { min: 7,  max: 7  }, // Barbados
  '375':   { min: 9,  max: 9  }, // Belarus
  '32':    { min: 8,  max: 9  }, // Belgium
  '501':   { min: 7,  max: 7  }, // Belize
  '229':   { min: 8,  max: 8  }, // Benin
  '1441':  { min: 7,  max: 7  }, // Bermuda
  '975':   { min: 8,  max: 8  }, // Bhutan
  '591':   { min: 8,  max: 8  }, // Bolivia
  '387':   { min: 8,  max: 8  }, // Bosnia Herzegovina
  '267':   { min: 7,  max: 8  }, // Botswana
  '55':    { min: 10, max: 11 }, // Brazil
  '673':   { min: 7,  max: 7  }, // Brunei
  '359':   { min: 8,  max: 9  }, // Bulgaria
  '226':   { min: 8,  max: 8  }, // Burkina Faso
  '257':   { min: 8,  max: 8  }, // Burundi
  '855':   { min: 8,  max: 9  }, // Cambodia
  '237':   { min: 9,  max: 9  }, // Cameroon
  '238':   { min: 7,  max: 7  }, // Cape Verde Islands
  '1345':  { min: 7,  max: 7  }, // Cayman Islands
  '236':   { min: 8,  max: 8  }, // Central African Republic
  '56':    { min: 9,  max: 9  }, // Chile
  '86':    { min: 11, max: 11 }, // China
  '57':    { min: 10, max: 10 }, // Colombia
  '269':   { min: 7,  max: 9  }, // Comoros / Mayotte
  '242':   { min: 9,  max: 9  }, // Congo
  '682':   { min: 5,  max: 5  }, // Cook Islands
  '506':   { min: 8,  max: 8  }, // Costa Rica
  '385':   { min: 8,  max: 9  }, // Croatia
  '53':    { min: 8,  max: 8  }, // Cuba
  '90392': { min: 7,  max: 7  }, // Cyprus North
  '357':   { min: 8,  max: 8  }, // Cyprus South
  '42':    { min: 9,  max: 9  }, // Czech Republic
  '45':    { min: 8,  max: 8  }, // Denmark
  '253':   { min: 8,  max: 8  }, // Djibouti
  '1809':  { min: 7,  max: 7  }, // Dominica / Dominican Republic
  '593':   { min: 8,  max: 9  }, // Ecuador
  '20':    { min: 10, max: 10 }, // Egypt
  '503':   { min: 8,  max: 8  }, // El Salvador
  '240':   { min: 9,  max: 9  }, // Equatorial Guinea
  '291':   { min: 7,  max: 7  }, // Eritrea
  '372':   { min: 7,  max: 8  }, // Estonia
  '251':   { min: 9,  max: 9  }, // Ethiopia
  '500':   { min: 5,  max: 5  }, // Falkland Islands
  '298':   { min: 6,  max: 6  }, // Faroe Islands
  '679':   { min: 7,  max: 7  }, // Fiji
  '358':   { min: 9,  max: 10 }, // Finland
  '33':    { min: 9,  max: 9  }, // France
  '594':   { min: 9,  max: 9  }, // French Guiana
  '689':   { min: 6,  max: 6  }, // French Polynesia
  '241':   { min: 7,  max: 8  }, // Gabon
  '220':   { min: 7,  max: 7  }, // Gambia
  '7880':  { min: 9,  max: 9  }, // Georgia
  '49':    { min: 10, max: 11 }, // Germany
  '233':   { min: 9,  max: 9  }, // Ghana
  '350':   { min: 8,  max: 8  }, // Gibraltar
  '30':    { min: 10, max: 10 }, // Greece
  '299':   { min: 6,  max: 6  }, // Greenland
  '1473':  { min: 7,  max: 7  }, // Grenada
  '590':   { min: 9,  max: 9  }, // Guadeloupe
  '671':   { min: 7,  max: 7  }, // Guam
  '502':   { min: 8,  max: 8  }, // Guatemala
  '224':   { min: 9,  max: 9  }, // Guinea
  '245':   { min: 9,  max: 9  }, // Guinea - Bissau
  '592':   { min: 7,  max: 7  }, // Guyana
  '509':   { min: 8,  max: 8  }, // Haiti
  '504':   { min: 8,  max: 8  }, // Honduras
  '852':   { min: 8,  max: 8  }, // Hong Kong
  '36':    { min: 9,  max: 9  }, // Hungary
  '354':   { min: 7,  max: 9  }, // Iceland
  '62':    { min: 9,  max: 12 }, // Indonesia
  '98':    { min: 10, max: 10 }, // Iran
  '964':   { min: 10, max: 10 }, // Iraq
  '353':   { min: 9,  max: 9  }, // Ireland
  '972':   { min: 9,  max: 9  }, // Israel
  '39':    { min: 9,  max: 11 }, // Italy
  '1876':  { min: 7,  max: 7  }, // Jamaica
  '81':    { min: 10, max: 10 }, // Japan
  '962':   { min: 9,  max: 9  }, // Jordan
  '7':     { min: 10, max: 10 }, // Kazakhstan / Russia / Tajikstan / Turkmenistan / Uzbekistan
  '254':   { min: 9,  max: 10 }, // Kenya
  '686':   { min: 5,  max: 5  }, // Kiribati
  '850':   { min: 8,  max: 10 }, // Korea North
  '82':    { min: 9,  max: 10 }, // Korea South
  '965':   { min: 8,  max: 8  }, // Kuwait
  '996':   { min: 9,  max: 9  }, // Kyrgyzstan
  '856':   { min: 8,  max: 10 }, // Laos
  '371':   { min: 8,  max: 8  }, // Latvia
  '961':   { min: 7,  max: 8  }, // Lebanon
  '266':   { min: 8,  max: 8  }, // Lesotho
  '231':   { min: 7,  max: 8  }, // Liberia
  '218':   { min: 9,  max: 9  }, // Libya
  '417':   { min: 7,  max: 7  }, // Liechtenstein
  '370':   { min: 8,  max: 8  }, // Lithuania
  '352':   { min: 8,  max: 9  }, // Luxembourg
  '853':   { min: 8,  max: 8  }, // Macao
  '389':   { min: 8,  max: 8  }, // Macedonia
  '261':   { min: 9,  max: 9  }, // Madagascar
  '265':   { min: 9,  max: 9  }, // Malawi
  '60':    { min: 9,  max: 10 }, // Malaysia
  '960':   { min: 7,  max: 7  }, // Maldives
  '223':   { min: 8,  max: 8  }, // Mali
  '356':   { min: 8,  max: 8  }, // Malta
  '692':   { min: 7,  max: 7  }, // Marshall Islands
  '596':   { min: 9,  max: 9  }, // Martinique
  '222':   { min: 8,  max: 8  }, // Mauritania
  '52':    { min: 10, max: 10 }, // Mexico
  '691':   { min: 7,  max: 7  }, // Micronesia
  '373':   { min: 8,  max: 8  }, // Moldova
  '377':   { min: 8,  max: 9  }, // Monaco
  '976':   { min: 8,  max: 8  }, // Mongolia
  '1664':  { min: 7,  max: 7  }, // Montserrat
  '212':   { min: 9,  max: 9  }, // Morocco
  '258':   { min: 9,  max: 9  }, // Mozambique
  '95':    { min: 7,  max: 10 }, // Myanmar
  '264':   { min: 7,  max: 10 }, // Namibia
  '674':   { min: 7,  max: 7  }, // Nauru
  '977':   { min: 10, max: 10 }, // Nepal
  '31':    { min: 9,  max: 9  }, // Netherlands
  '687':   { min: 6,  max: 6  }, // New Caledonia
  '64':    { min: 8,  max: 10 }, // New Zealand
  '505':   { min: 8,  max: 8  }, // Nicaragua
  '227':   { min: 8,  max: 8  }, // Niger
  '234':   { min: 10, max: 10 }, // Nigeria
  '683':   { min: 4,  max: 4  }, // Niue
  '672':   { min: 6,  max: 6  }, // Norfolk Islands
  '670':   { min: 7,  max: 7  }, // Northern Marianas
  '47':    { min: 8,  max: 8  }, // Norway
  '968':   { min: 8,  max: 8  }, // Oman
  '680':   { min: 7,  max: 7  }, // Palau
  '507':   { min: 8,  max: 8  }, // Panama
  '675':   { min: 8,  max: 8  }, // Papua New Guinea
  '595':   { min: 9,  max: 9  }, // Paraguay
  '51':    { min: 9,  max: 9  }, // Peru
  '63':    { min: 10, max: 10 }, // Philippines
  '48':    { min: 9,  max: 9  }, // Poland
  '351':   { min: 9,  max: 9  }, // Portugal
  '1787':  { min: 7,  max: 7  }, // Puerto Rico
  '974':   { min: 8,  max: 8  }, // Qatar
  '262':   { min: 9,  max: 9  }, // Reunion
  '40':    { min: 9,  max: 9  }, // Romania
  '250':   { min: 9,  max: 9  }, // Rwanda
  '378':   { min: 6,  max: 10 }, // San Marino
  '239':   { min: 7,  max: 7  }, // Sao Tome & Principe
  '966':   { min: 9,  max: 9  }, // Saudi Arabia
  '221':   { min: 9,  max: 9  }, // Senegal
  '381':   { min: 8,  max: 9  }, // Serbia
  '248':   { min: 7,  max: 7  }, // Seychelles
  '232':   { min: 8,  max: 8  }, // Sierra Leone
  '421':   { min: 9,  max: 9  }, // Slovak Republic
  '386':   { min: 8,  max: 8  }, // Slovenia
  '677':   { min: 5,  max: 5  }, // Solomon Islands
  '252':   { min: 7,  max: 8  }, // Somalia
  '27':    { min: 9,  max: 9  }, // South Africa
  '34':    { min: 9,  max: 9  }, // Spain
  '94':    { min: 9,  max: 9  }, // Sri Lanka
  '290':   { min: 4,  max: 4  }, // St. Helena
  '1869':  { min: 7,  max: 7  }, // St. Kitts
  '1758':  { min: 7,  max: 7  }, // St. Lucia
  '249':   { min: 9,  max: 9  }, // Sudan
  '597':   { min: 6,  max: 7  }, // Suriname
  '268':   { min: 8,  max: 8  }, // Swaziland
  '46':    { min: 7,  max: 10 }, // Sweden
  '41':    { min: 9,  max: 9  }, // Switzerland
  '963':   { min: 9,  max: 9  }, // Syria
  '886':   { min: 9,  max: 9  }, // Taiwan
  '66':    { min: 9,  max: 9  }, // Thailand
  '228':   { min: 8,  max: 8  }, // Togo
  '676':   { min: 5,  max: 5  }, // Tonga
  '1868':  { min: 7,  max: 7  }, // Trinidad & Tobago
  '216':   { min: 8,  max: 8  }, // Tunisia
  '90':    { min: 10, max: 10 }, // Turkey
  '993':   { min: 8,  max: 8  }, // Turkmenistan
  '1649':  { min: 7,  max: 7  }, // Turks & Caicos Islands
  '688':   { min: 5,  max: 5  }, // Tuvalu
  '256':   { min: 9,  max: 9  }, // Uganda
  '380':   { min: 9,  max: 9  }, // Ukraine
  '598':   { min: 8,  max: 8  }, // Uruguay
  '678':   { min: 5,  max: 7  }, // Vanuatu
  '379':   { min: 6,  max: 10 }, // Vatican City
  '58':    { min: 10, max: 10 }, // Venezuela
  '84':    { min: 9,  max: 10 }, // Vietnam
  '1284':  { min: 7,  max: 7  }, // Virgin Islands - British
  '1340':  { min: 7,  max: 7  }, // Virgin Islands - US
  '681':   { min: 6,  max: 6  }, // Wallis & Futuna
  '969':   { min: 9,  max: 9  }, // Yemen North
  '967':   { min: 9,  max: 9  }, // Yemen South
  '260':   { min: 9,  max: 9  }, // Zambia
  '263':   { min: 9,  max: 10 }, // Zimbabwe
};

export const DEFAULT_MOBILE_LENGTH = { min: 6, max: 15 };
